import { put, select, takeLatest } from 'redux-saga/effects'
import { TabConstants } from '../../../components/tabs/Tabs.constants'
import { getPnProcedureOptionsSelector } from '../../options/selectors/pnProcedureOptions.selector '
import { IPertinentNegativeProcedureOptionsState } from '../../options/store/options.types'
import { getPnProcedureSelector } from '../../procedures/pnProcedure/selectors/pnProcedure.selector'
import {
  IPnProcedureOptions,
  IPnProcedureMetadata,
  IPnProcedureState,
  IPnProcedureTimelineOption,
} from '../../procedures/pnProcedure/store/pnProcedure.types'
import { getPatientTimelineSelector } from '../selectors/patientTimeline.selector'
import { saveTimelineItems, setActivityLog } from '../store/timeline.actions'
import { TimelineConstants } from '../store/timeline.constants'
import { IItem, ITimelineState } from '../store/timeline.types'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'

export function* addPertinentNegativeProcedureItem() {
  const timeline: ITimelineState = yield select(getPatientTimelineSelector)
  const { items } = timeline
  const pnProcedureState: IPnProcedureState = yield select(getPnProcedureSelector)
  const pnProcedureOptions: IPertinentNegativeProcedureOptionsState = yield select(getPnProcedureOptionsSelector)

  const { pertinentNegativeProcedureOptions } = pnProcedureOptions
  const { key, addToTimeline, date, time, pta, procedurePNNVs } = pnProcedureState
  const filteredPertNegativeProcedureOptions: IPnProcedureTimelineOption[] = []

  try {
    procedurePNNVs?.forEach((selectedOption) => {
      pertinentNegativeProcedureOptions.forEach((data: IPnProcedureOptions) => {
        const label = data?.categoryOptions?.find(
          (label: IPnProcedureMetadata) => label.id === Number(selectedOption?.nemsisCode)
        )

        if (label) {
          const option = label.options.find(
            (opt) =>
              (selectedOption.nemsisCodePNNV?.pn !== '' && opt.id === Number(selectedOption.nemsisCodePNNV?.pn)) ||
              (selectedOption.nemsisCodePNNV?.nv !== '' && opt.id === Number(selectedOption.nemsisCodePNNV?.nv))
          )

          if (option) {
            filteredPertNegativeProcedureOptions.push({
              categoryOption: label.name,
              selectedOption: option?.name || '',
            })
          }
        }
      })
    })
    if (addToTimeline) {
      const index = items.findIndex((item) => item.key === key)
      const dateTime = new Date(date || 0)
      if (time) {
        if (time.split(':').length >= 3) dateTime.setSeconds(+time.split(':')[2])
        dateTime.setMinutes(+time.split(':')[1])
        dateTime.setHours(+time.split(':')[0])
      }
      const eventHeaders = filteredPertNegativeProcedureOptions
        .map((item: IPnProcedureTimelineOption) => {
          return `${item.categoryOption}: ${item.selectedOption}`
        })
        .join('; ')

      const item: IItem = {
        key: key,
        grid: true,
        labelHeader: time,
        subHeader: date,
        labelHeaderFlag: pta ? 'PTA' : '',
        itemType: 'Procedures',
        event: 'Pertinent Negative Procedure',
        eventSubHeader: `${eventHeaders}`,
        rowActionType: TimelineConstants.SET_PN_PROCEDURE_ITEM,
        defaultHref: TabConstants.PERTINENT_NEGATIVE_PROCEDURE,
        date: dateTime,
      }
      if (index !== -1) {
        items[index] = item
      } else {
        items.push(item)
      }

      yield put(setActivityLog(items))
      yield put(saveTimelineItems())
    }
  } catch (e) {
    yield put(throwPcrException(`addPertinentNegativeProcedureItem() error: ${e}`))
  }
}

export function* addPertinentNegativeProcedureItemSaga() {
  yield takeLatest([TimelineConstants.ADD_PN_PROCEDURE_ITEM], performWithMutexHOG, addPertinentNegativeProcedureItem)
}
